import { render } from "./PayInRequisites.vue?vue&type=template&id=aa3081c6&ts=true"
import script from "./PayInRequisites.vue?vue&type=script&lang=ts"
export * from "./PayInRequisites.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__